module.exports = require("./ff-Adlm-SL.d.ts");